var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "7wjjowk16a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.607843 0 0 0 0 0.607843 0 0 0 0 0.607843 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27 -136) translate(0 121)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M29.474 13.049l-.003-.003L17.232.81C16.711.287 16.017 0 15.28 0c-.737 0-1.43.287-1.953.81L1.094 13.04l-.013.013c-1.07 1.077-1.069 2.825.006 3.9.49.49 1.139.775 1.832.805.029.003.057.004.086.004h.487v9.006C3.492 28.55 4.942 30 6.725 30h4.788c.486 0 .88-.394.88-.879v-7.06c0-.814.661-1.475 1.474-1.475h2.825c.813 0 1.474.661 1.474 1.475v7.06c0 .485.394.879.88.879h4.788c1.782 0 3.232-1.45 3.232-3.232v-9.006h.453c.737 0 1.43-.287 1.953-.81 1.076-1.075 1.076-2.827.002-3.903zm-1.245 2.661c-.19.19-.442.294-.71.294h-1.332c-.485 0-.879.394-.879.88v9.884c0 .813-.661 1.474-1.474 1.474h-3.91v-6.181c0-1.783-1.45-3.233-3.232-3.233h-2.825c-1.782 0-3.233 1.45-3.233 3.233v6.181H6.725c-.813 0-1.475-.661-1.475-1.474v-9.885c0-.485-.393-.879-.879-.879H3.063l-.041-.001c-.262-.005-.508-.109-.692-.293-.391-.392-.391-1.029 0-1.42l.001-.001L14.57 2.052c.19-.19.441-.294.71-.294.268 0 .52.104.71.294l12.235 12.234.006.006c.39.392.388 1.027-.002 1.418z",
    transform: "translate(27.441 15)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.84f87c2045def292b43a061cc8d72a51.svg";
export { ForwardRef as ReactComponent };